// © 2025 Camp Promethean, LLC. All Rights Reserved.

import { useEffect, useState } from "react";

/** Show loading UI only after `delayMs` to avoid flicker on fast resolves. */
export function useDelayedLoading(isLoading: boolean, delayMs = 180) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!isLoading) {
      setShow(false);
      return;
    }

    const timer = window.setTimeout(() => setShow(true), delayMs);
    return () => window.clearTimeout(timer);
  }, [isLoading, delayMs]);

  return isLoading && (delayMs <= 0 || show);
}
